import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_FOREST } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/adventure-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/adventure-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/adventure-extreme.guitar.json' with { type: 'json' };

export const ADVENTURE_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'adventure',
  baseTitle: "Adventure",
  description: "JJD's melodic glitch-hop on a UwU_005 mania set. Patterns track the synth hooks tightly.",
  difficulty: 3,
  palette: PALETTE_FOREST,
  audioSrc: '/audio/guitar/adventure.mp3',
  attribution: "\"Adventure\" by JJD [NCS Release] - https://ncs.io/Adventure",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
